import { render } from "./AppNavigationList.vue?vue&type=template&id=2caf34f5&ts=true"
import script from "./AppNavigationList.vue?vue&type=script&lang=ts"
export * from "./AppNavigationList.vue?vue&type=script&lang=ts"

import "./AppNavigationList.vue?vue&type=style&index=0&id=2caf34f5&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__